/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/StakeholderBenchmarkDimensionValue', 'model/StakeholderBenchmarkDimensionValuePaginationSlice'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/StakeholderBenchmarkDimensionValue'), require('../model/StakeholderBenchmarkDimensionValuePaginationSlice'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.StakeholderBenchmarkDimensionValueApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.StakeholderBenchmarkDimensionValue, root.ForStractionServiceApi.StakeholderBenchmarkDimensionValuePaginationSlice);
  }
}(this, function(ApiClient, StakeholderBenchmarkDimensionValue, StakeholderBenchmarkDimensionValuePaginationSlice) {
  'use strict';

  /**
   * StakeholderBenchmarkDimensionValue service.
   * @module api/StakeholderBenchmarkDimensionValueApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new StakeholderBenchmarkDimensionValueApi. 
   * @alias module:api/StakeholderBenchmarkDimensionValueApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the stakeholderBenchmarkDimensionValueAddAllPut operation.
     * @callback module:api/StakeholderBenchmarkDimensionValueApi~stakeholderBenchmarkDimensionValueAddAllPutCallback
     * @param {String} error Error message, if any.
     * @param {Array.<'Integer'>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * addAll
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/StakeholderBenchmarkDimensionValue>} body 
     * @param {module:api/StakeholderBenchmarkDimensionValueApi~stakeholderBenchmarkDimensionValueAddAllPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<'Integer'>}
     */
    this.stakeholderBenchmarkDimensionValueAddAllPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling stakeholderBenchmarkDimensionValueAddAllPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling stakeholderBenchmarkDimensionValueAddAllPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = ['Integer'];

      return this.apiClient.callApi(
        '/StakeholderBenchmarkDimensionValue/addAll', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the stakeholderBenchmarkDimensionValueAddPut operation.
     * @callback module:api/StakeholderBenchmarkDimensionValueApi~stakeholderBenchmarkDimensionValueAddPutCallback
     * @param {String} error Error message, if any.
     * @param {'Integer'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * add
     * @param {String} _4SAPIAppID 
     * @param {module:model/StakeholderBenchmarkDimensionValue} body 
     * @param {module:api/StakeholderBenchmarkDimensionValueApi~stakeholderBenchmarkDimensionValueAddPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'Integer'}
     */
    this.stakeholderBenchmarkDimensionValueAddPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling stakeholderBenchmarkDimensionValueAddPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling stakeholderBenchmarkDimensionValueAddPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Integer';

      return this.apiClient.callApi(
        '/StakeholderBenchmarkDimensionValue/add', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the stakeholderBenchmarkDimensionValueDeleteAllPut operation.
     * @callback module:api/StakeholderBenchmarkDimensionValueApi~stakeholderBenchmarkDimensionValueDeleteAllPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * deleteAll
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/Integer>} body 
     * @param {module:api/StakeholderBenchmarkDimensionValueApi~stakeholderBenchmarkDimensionValueDeleteAllPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.stakeholderBenchmarkDimensionValueDeleteAllPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling stakeholderBenchmarkDimensionValueDeleteAllPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling stakeholderBenchmarkDimensionValueDeleteAllPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/StakeholderBenchmarkDimensionValue/deleteAll', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the stakeholderBenchmarkDimensionValueDeleteGet operation.
     * @callback module:api/StakeholderBenchmarkDimensionValueApi~stakeholderBenchmarkDimensionValueDeleteGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * delete
     * @param {String} _4SAPIAppID 
     * @param {Integer} entityID 
     * @param {module:api/StakeholderBenchmarkDimensionValueApi~stakeholderBenchmarkDimensionValueDeleteGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.stakeholderBenchmarkDimensionValueDeleteGet = function(_4SAPIAppID, entityID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling stakeholderBenchmarkDimensionValueDeleteGet";
      }

      // verify the required parameter 'entityID' is set
      if (entityID == undefined || entityID == null) {
        throw "Missing the required parameter 'entityID' when calling stakeholderBenchmarkDimensionValueDeleteGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'entityID': entityID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/StakeholderBenchmarkDimensionValue/delete', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the stakeholderBenchmarkDimensionValueEditAllPut operation.
     * @callback module:api/StakeholderBenchmarkDimensionValueApi~stakeholderBenchmarkDimensionValueEditAllPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * editAll
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/StakeholderBenchmarkDimensionValue>} body 
     * @param {module:api/StakeholderBenchmarkDimensionValueApi~stakeholderBenchmarkDimensionValueEditAllPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.stakeholderBenchmarkDimensionValueEditAllPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling stakeholderBenchmarkDimensionValueEditAllPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling stakeholderBenchmarkDimensionValueEditAllPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/StakeholderBenchmarkDimensionValue/editAll', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the stakeholderBenchmarkDimensionValueEditPut operation.
     * @callback module:api/StakeholderBenchmarkDimensionValueApi~stakeholderBenchmarkDimensionValueEditPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * edit
     * @param {String} _4SAPIAppID 
     * @param {module:model/StakeholderBenchmarkDimensionValue} body 
     * @param {module:api/StakeholderBenchmarkDimensionValueApi~stakeholderBenchmarkDimensionValueEditPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.stakeholderBenchmarkDimensionValueEditPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling stakeholderBenchmarkDimensionValueEditPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling stakeholderBenchmarkDimensionValueEditPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/StakeholderBenchmarkDimensionValue/edit', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the stakeholderBenchmarkDimensionValueLoadGet operation.
     * @callback module:api/StakeholderBenchmarkDimensionValueApi~stakeholderBenchmarkDimensionValueLoadGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/StakeholderBenchmarkDimensionValue} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * load
     * @param {String} _4SAPIAppID 
     * @param {Integer} valueID 
     * @param {module:api/StakeholderBenchmarkDimensionValueApi~stakeholderBenchmarkDimensionValueLoadGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/StakeholderBenchmarkDimensionValue}
     */
    this.stakeholderBenchmarkDimensionValueLoadGet = function(_4SAPIAppID, valueID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling stakeholderBenchmarkDimensionValueLoadGet";
      }

      // verify the required parameter 'valueID' is set
      if (valueID == undefined || valueID == null) {
        throw "Missing the required parameter 'valueID' when calling stakeholderBenchmarkDimensionValueLoadGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'valueID': valueID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = StakeholderBenchmarkDimensionValue;

      return this.apiClient.callApi(
        '/StakeholderBenchmarkDimensionValue/load', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the stakeholderBenchmarkDimensionValueSearchPut operation.
     * @callback module:api/StakeholderBenchmarkDimensionValueApi~stakeholderBenchmarkDimensionValueSearchPutCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/StakeholderBenchmarkDimensionValue>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * search
     * @param {String} _4SAPIAppID 
     * @param {module:model/StakeholderBenchmarkDimensionValue} body 
     * @param {module:api/StakeholderBenchmarkDimensionValueApi~stakeholderBenchmarkDimensionValueSearchPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/StakeholderBenchmarkDimensionValue>}
     */
    this.stakeholderBenchmarkDimensionValueSearchPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling stakeholderBenchmarkDimensionValueSearchPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling stakeholderBenchmarkDimensionValueSearchPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [StakeholderBenchmarkDimensionValue];

      return this.apiClient.callApi(
        '/StakeholderBenchmarkDimensionValue/search', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the stakeholderBenchmarkDimensionValueSearchSlicePut operation.
     * @callback module:api/StakeholderBenchmarkDimensionValueApi~stakeholderBenchmarkDimensionValueSearchSlicePutCallback
     * @param {String} error Error message, if any.
     * @param {module:model/StakeholderBenchmarkDimensionValuePaginationSlice} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * searchSlice
     * @param {String} _4SAPIAppID 
     * @param {module:model/StakeholderBenchmarkDimensionValue} body 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.startID  (default to 0)
     * @param {Integer} opts.maxCount  (default to 0)
     * @param {Integer} opts.slicingOrder  (default to 0)
     * @param {module:api/StakeholderBenchmarkDimensionValueApi~stakeholderBenchmarkDimensionValueSearchSlicePutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/StakeholderBenchmarkDimensionValuePaginationSlice}
     */
    this.stakeholderBenchmarkDimensionValueSearchSlicePut = function(_4SAPIAppID, body, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling stakeholderBenchmarkDimensionValueSearchSlicePut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling stakeholderBenchmarkDimensionValueSearchSlicePut";
      }


      var pathParams = {
      };
      var queryParams = {
        'startID': opts['startID'],
        'maxCount': opts['maxCount'],
        'slicingOrder': opts['slicingOrder']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = StakeholderBenchmarkDimensionValuePaginationSlice;

      return this.apiClient.callApi(
        '/StakeholderBenchmarkDimensionValue/searchSlice', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
